<template>
<div class="field-select" :class="[open ? 'open' : '']">
	<div class="field-select__btn"  @click="open = !open">
		<span class="field-select__text" v-if="localValue">{{localValue.name}}</span>
		<span class="field-select__placeholder" v-else>{{placeholder}}</span>
		<svg class="field-select__btn-icon"><use href="#svg-icon-chevron"></use></svg>
		<select class="field-select__select" v-if="mobile" @change="handlerSelectChange($event)" @click.stop="() => {}">
			<option disabled selected>Не выбрано</option>
			<option :value="option.id" v-for="option in options" :key="option.id">{{option.name}}</option>
		</select>
	</div>
	<transition name="fade">
		<div class="field-select__options" v-if="open">
			<div class="field-select__option" v-for="option in options" :key="option.id" @click="handlerOptionClick(option)">{{option.name}}</div>
		</div>
	</transition>
</div>

</template>

<script>

import breakpointsMixin from "../../mixins/breakpoints-mixin.vue";

export default {

	mixins: [
		breakpointsMixin
	],

	emits: [
		'update:model-value'
	],

	props: {
		options: {
			type: Array,
			default: []
		},

		value: {
			type: Object,
			default: null
		},

		placeholder: {
			type: String,
			default: null
		}
	},

	data() {
		return {
			localValue: null,
			open: false
		}
	},

	computed: {
		mobile() {
			return this.isMob || this.$isMobile();
		}
	},

	watch: {
		value(state) {
			this.localValue = state;
		}
	},

	mounted() {
		document.addEventListener('click', this.handlerOutsideClick);
	},

	unmounted() {
		document.removeEventListener('click', this.handlerOutsideClick);
	},

	methods: {
		handlerOptionClick(option) {
			this.localValue = option;
			this.open = false
			this.$emit('update:model-value', this.localValue);
		},

		handlerOutsideClick(e) {
			if (!this.$el.contains(e.target)) {
				this.open = false;
			}
		},

		handlerSelectChange(e) {
			this.localValue = this.options.find(option => option.id == e.target.value);
			this.open = false;
			this.$emit('update:model-value', this.localValue);
		}
	}
}

</script>
